

document.querySelectorAll('[bss-b2b-product-price]').forEach(priceEl => {
  const productId = priceEl.getAttribute('bss-b2b-product-id');
  const skeleton = document.getElementById(`price-skeleton-${productId}`);
  if (!skeleton) return;

  // Replace skeleton content with the animated SVG loader
  skeleton.innerHTML = `
    <svg class="transient" width="20" viewBox="0 0 120 30" fill="currentColor" style="opacity: 1; transform: translate(-50%, -50%);">
      <circle cx="15" cy="15" r="15">
        <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate>
        <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate>
      </circle>
      <circle cx="60" cy="15" r="9" fill-opacity="0.3">
        <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite"></animate>
        <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite"></animate>
      </circle>
      <circle cx="105" cy="15" r="15">
        <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite"></animate>
        <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite"></animate>
      </circle>
    </svg>
  `;

  const observer = new MutationObserver(() => {
    if (priceEl.innerHTML.trim() !== '') {
      skeleton.style.display = 'none';
      priceEl.setAttribute('data-loaded', '');
      observer.disconnect();
    }
  });

  observer.observe(priceEl, { childList: true, subtree: true });

  // Fallback: hide skeleton after 15s regardless
  setTimeout(() => {
    skeleton.style.display = 'none';
  }, 20000);
});